export default "__VITE_ASSET__CYoAreOX__"